'use strict';

module.exports = ['ngDroProfile', '$q', function (ngDroProfile, $q) {
        /*  
         *  Restituisce una promise che viene risolto quando tutte i promise nell'iterable passato come parametro vengono risolti, 
         *  TODO: o scatena una reject contenente la ragione del primo promise che viene rigettato.
         */
        function canDoPromise(resource, perms) {
            var promises = [];
            if (perms === undefined) {
                perms = ["CREATE", "UPDATE", "DELETE"]; // default se non vengono passate
            }
            for (var p in perms) {
                promises.push($q(function (resolve, reject) {
                    var canDoRtn = {};
                    var permName = perms[p];
                    ngDroProfile.canDo(resource, permName)
                            .then(function (response) {
                                canDoRtn[permName] = response.data;
                                resolve(canDoRtn);
                            })
                            .catch(function (err) {});
                }));
            }
            return $q.all(promises);
        }


        /*
         * Restituisce una promise
         */
        function canDo(resource, permsArr) {
            return $q(function (resolve, reject) {
                var permsObject = {};
                canDoPromise(resource, permsArr)
                        .then(function (perms) {
                            for (var i in perms) {
                                for (var n in perms[i]) {
                                    permsObject[n] = perms[i][n];
                                }
                            }
                            resolve(permsObject);
                        })
                        .catch(function (err) {
                            reject(err);
                        });
            });
        }


        function canDoBy__p(event) {
            var jdroPerms = {};
            jdroPerms.UPDATE = -1 !== event.__p.indexOf("UPDATE");
            jdroPerms.DELETE = -1 !== event.__p.indexOf("DELETE");
            jdroPerms.CREATE = -1 !== event.__p.indexOf("CREATE");
            jdroPerms.VOTE = -1 !== event.__p.indexOf("VOTE");
            jdroPerms.START = -1 !== event.__p.indexOf("START");
            return jdroPerms;
        }


        return {
            // funzione da chiamare quando vuoi usare la REST per chiedere i permessi
            canDo: canDo,
            // funzione da chiamare quando i permessi sono settati nella risorsa.__p
            canDoBy__p: canDoBy__p
        };
    }];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/canDoService.js
// module id = 387
// module chunks = 0